import {
  fetchCertainPaymentMethodEpic,
  PAYMENT_METHOD_FEATURE_KEY,
  paymentMethodReducer,
} from '@cashier/cashier-data-access';
import { createFeature } from '@cashier/cashier-shared';

import {
  fillPaymentFormMiddleware,
  paymentFormMiddleware,
} from './lib/middlewares';
import { PaymentForm as PaymentFormV2 } from './lib/v2';
import { PaymentForm as PaymentFormV3 } from './lib/v3';
import { PaymentForm as PaymentFormV4 } from './lib/v4';

export const PaymentFormFeature = createFeature({
  component: {
    PaymentFormV2,
    PaymentFormV3,
    PaymentFormV4,
  },

  hook: {},

  store: {
    epics: [fetchCertainPaymentMethodEpic],

    middlewares: [fillPaymentFormMiddleware, paymentFormMiddleware],

    reducerMap: {
      [PAYMENT_METHOD_FEATURE_KEY]: paymentMethodReducer,
    },
  },
});
